export default __webpack_public_path__ + "static/media/Montserrat-Bold.0dff9e80.woff";